<template>
  <div class="resource-list-box">
    <!--操作栏-->
    <div class="action-bar" style="display: flex;align-items: baseline;margin-bottom: 0!important;">
      <el-button
          type="primary"
          size="small"
          @click="resourceOperation('add')"
          class="add-input"
      >+新增配置
      </el-button
      >
      <el-select @change="getResourceList" placeholder="选择设备类型"
                 v-model.number="params.devType" size="small"
                 style="width:100px">
        <el-option :value="0" label="全部"></el-option>
        <el-option :value="1" label="安卓"></el-option>
        <el-option :value="2" label="IOS"></el-option>
        <el-option :value="3" label="通用"></el-option>
      </el-select>

      <el-button
          type="success"
          size="small"
          @click="getResourceList"
      >刷新</el-button>
    </div>
    <!--数据表格-->
    <el-table
        :data="tableData"
        size="small"
        v-loading="loading"
        height='calc(100vh - 200px)'
        style="width: 100%"
    >

      <el-table-column type="expand">
        <template slot-scope="props">
          <div class="linebox">
          <table class="line-tab">
            <tr>
              <th style="width:200px" v-if="props.row.type == 'IOSVERSION' || props.row.type=='ANDROIDVERSION'">版本
              </th>
              <th style="width:200px" v-else>标题</th>
              <th style="width:calc(100% - 300px)" v-if="props.row.type == 'PLAYCONFIG'">免费观影时长</th>
              <th style="width:calc(100% - 300px)" v-else-if="props.row.type == 'VIPCARD'">布局方式</th>
              <th style="width:calc(100% - 300px)"
                  v-else-if="props.row.type == 'IOSVERSION' || props.row.type=='ANDROIDVERSION'">强更下载地址
              </th>
              <th style="width:calc(100% - 300px)" v-else-if="props.row.type == 'MODULESELECTINDEX'">默认选中</th>
              <th style="width:calc(100% - 300px)" v-else>地址</th>
              <th style="width:100px" v-if="props.row.type == 'PLAYCONFIG'">观影次数</th>
              <th style="width:100px" v-else-if="props.row.type == 'VIPCARD'">社区布局方式</th>
              <th style="width:100px" v-else-if="props.row.type == 'IOSVERSION'  || props.row.type=='ANDROIDVERSION'">
                是否开启强更
              </th>
              <th style="width:100px" v-else-if="props.row.type == 'MODULESELECTINDEX'">默认选中</th>
              <th style="width:100px" v-else-if="props.row.type == 'NAVOPEN'">是否打开</th>
              <th style="width:100px" v-else>地址</th>
              <th style="width:100px">状态</th>
            </tr>
            <tr v-for="(item) in props.row.domain" :key="item.url">
              <td>{{ item.title }}</td>
              <td>{{ item.url }}</td>
              <td v-if=" props.row.type == 'VIPCARD'">{{ item.weight }}={{ item.weight == 0 ? "横版" : "竖版" }}</td>
              <td v-else-if="props.row.type == 'COMMUNITYLAYOUT'">{{
                  item.weight
                }}({{ item.weight == 0 ? "三大一小" : "横版" }})
              </td>
              <td v-else-if="props.row.type == 'IOSVERSION'  || props.row.type=='ANDROIDVERSION' || props.row.type=='NAVOPEN'">{{
                  item.weight
                }}({{ item.weight == 0 ? "关闭" : "开启" }})
              </td>
              <td v-else>{{ item.weight }}</td>
              <td>
                <div v-loading="item.checked == 1"></div>
                <div class="green" v-if="item.checked == 2">正常</div>
                <div class="red" v-if="item.checked == 0">异常</div>
              </td>
            </tr>
          </table>
          </div>
        </template>
      </el-table-column>

      <el-table-column
          prop="title"
          label="设备类型"
          align="left"
          min-width="100"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.devType == 1" class="green fw">安卓</span>
          <span v-if="scope.row.devType == 2" class="red fw">IOS</span>
          <span v-if="scope.row.devType == 3" class="yellow fw">通用</span>
        </template>
      </el-table-column>
      <el-table-column
          prop="isActive"
          label="标题"
          align="left"
          min-width="100"
      >
        <template slot-scope="scope">
           {{ scope.row.type | typeRule}}
        </template>
      </el-table-column>
      <el-table-column
          prop="type"
          label="类型"
          align="left"
          min-width="100"
      >
        <template slot-scope="scope">
           {{ scope.row.type}}
        </template>
      </el-table-column>
      <el-table-column
          prop="sorted"
          label="最后修改时间/修改人"
          align="left"
          min-width="160"
      >
        <template slot-scope="scope">
          {{ scope.row.updatedAt | changeDate}} <span v-if="scope.row.updatedOp"> - ({{ scope.row.updatedOp}})</span>
        </template>
      </el-table-column>
      <el-table-column
          prop="sorted"
          label="排序"
          align="left"
          min-width="100"
      >
        <template slot-scope="scope">
          {{ scope.row.sorted}}
        </template>
      </el-table-column>
      <el-table-column
          prop="isActive"
          label="激活状态"
          align="left"
          min-width="100"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.isActive" class="green">运行中</span>
          <span v-else class="red">关闭中</span>
        </template>
      </el-table-column>
      <el-table-column
          label="操作"
          align="right"
          min-width="120"
      >
        <template slot-scope="scope">
          <el-button
              type="success"
              size="mini"
              icon="el-icon-edit"
              @click="resourceOperation('edit', scope.row)"
          ></el-button>
          <el-button
              v-if="false"
              type="danger"
              size="mini"
              icon="el-icon-delete"
              @click="removeResource(scope.row.id)"
          ></el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--新增、编辑弹框-->
    <resource-action
        ref="resourceAction"
        @handlerResourceList="getResourceList()"
    ></resource-action>
  </div>
</template>

<script>
import API from "@/api";
import ResourceAction from "./components/resourceAction";

export default {
  data() {
    return {
      // 表格数据加载动画
      loading: false,
      // 列表数据
      tableData: [],
      copyTableData: [],
      total: 0,
      currentType: 0,
      params: {
        devType: 0
      },
    };
  },
  components: {
    ResourceAction,
  },
  filters: {
    typeRule(value) {
      let typeList = {
        API: "安卓APPAPI服务域名",
        VID: "安卓视频专用域名(CDN)",
        IMAGE: "安卓图片专用域名(CDN)",
        COMMON: "视频，图片公用(CDN)",
        GROUP: "官方群号",
        CUST: "客服中心",
        BUSINESS: "商务群&渠道群",
        PLAYCONFIG: "免费观影配置",
        OFFICALWEBSITEADDRESS: "官网地址",
        NAVLINKADDR: "导航站线路地址",
        IOSAPI: "IOSApp服务API资源域名",
        IOSVID: "IOS视频资源地址（CDN）",
        IOSIMAGE: "IOS图片资源地址（CDN）",
        VIPCARD: "会员卡展示",
        NAVOPEN: "金刚区总开关",
        MODULESELECTINDEX: "模块默认选中子元素",
        ANDROIDVERSION: "安卓apk下载地址和版本控制",
        IOSVERSION: "IOS下载地址和版本控制",
        COMMUNITYLAYOUT: "社区数据布局",
        SOURCEKEYWORDS: "片源搜索关键词",
        COINIMG: "金币充值引导图",
        MARKIMG: "全局角标控制",
      };
      return typeList[value] ? typeList[value] : "未知";
    },
  },
  created() {
    this.getResourceList();
  },
  methods: {
    // 请求资源列表
    getResourceList() {
      this.loading = true;
      API.getSourceList(this.params)
          .then((res) => {
            if (res.code === 200 && res.data) {
              this.tableData = res.data.map(c => {
                c.domain.map(cc => {
                  cc.checked = 2;
                  return cc;
                })
                return c;
              });
              this.copyTableData = res.data;
              this.total = res.total;
            } else {
              this.tableData = [];
              this.copyTableData = [];
              this.total = 0;
            }
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
    }
    ,
    // 删除资源
    removeResource(id) {
      this.$confirm("您确定要删除当前资源吗？", "删除提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
          .then(() => {
            API.deleteSource({ids: [id]}).then((res) => {
              if (res.code === 200) {
                this.$message({
                  message: "删除资源成功",
                  type: "success",
                });
                this.getResourceList();
              } else {
                this.$message.error("删除资源失败");
              }
            });
          })
          .catch(() => {
          });
    }
    ,
    // 新增、编辑操作
    resourceOperation(type, data) {
      this.$refs.resourceAction.open(type, data);
    }
    ,
  }
  ,
}
;
</script>

<style lang="scss">
.resource-list-box {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .add-input {
    margin-left: 0 !important;
  }

  .el-table {
    border: 1px solid #eee;
  }

  .el-table .success-row {
    background: #f0f9eb;
  }

  .linebox {
    padding: 10px;

    .line-tab {
      width: 100%;
      border-collapse: collapse;

      th, td {
        border: 1px solid #eee;
        padding: 10px;
      }
    }
  }
}
</style>
